// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root_23ciP"};